var _a;
import { ProductNumberBlockReasonEnum } from "../types/Api";
import { ErrorType } from "../types/ErrorType";
/**
 * Translates a product number block reason enum value into a localized label.
 * Shared between the product number detail view and the blocked badge in the list.
 *
 * @param intl active react-intl instance
 * @param reason block reason enum value (or its raw string); null/undefined when not blocked
 * @returns localized reason label, or undefined when no reason is provided
 */
export var getBlockReasonTranslation = function (intl, reason) {
    switch (reason) {
        case ProductNumberBlockReasonEnum.UNAUTHORIZED_USE:
            return intl.formatMessage({
                id: "ui-br-agency.product-number.blockReason.unauthorizedUse",
            });
        case ProductNumberBlockReasonEnum.PRESUMED_PUBLISHED:
            return intl.formatMessage({
                id: "ui-br-agency.product-number.blockReason.presumedPublished",
            });
        case ProductNumberBlockReasonEnum.USED_BEFORE_REGISTRY:
            return intl.formatMessage({
                id: "ui-br-agency.product-number.blockReason.usedBeforeRegistry",
            });
        case ProductNumberBlockReasonEnum.PRODUCT_DELETED:
            return intl.formatMessage({
                id: "ui-br-agency.product-number.blockReason.productDeleted",
            });
        default:
            return reason !== null && reason !== void 0 ? reason : undefined;
    }
};
/**
 * True for a number retired on product delete — it stays blocked forever, so
 * it cannot be unblocked, re-blocked or legalized.
 */
export var isRetiredProductNumber = function (productNumber) {
    return !!(productNumber === null || productNumber === void 0 ? void 0 : productNumber.blocked) &&
        productNumber.blockReason === ProductNumberBlockReasonEnum.PRODUCT_DELETED;
};
var BLOCK_ACTION_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.PRODUCT_NUMBER_RETIRED] = "ui-br-agency.product-number.error.retired",
    _a[ErrorType.PRODUCT_DELETED_BLOCK_REASON_NOT_ALLOWED] = "ui-br-agency.product-number.error.productDeletedReasonNotAllowed",
    _a);
/** Maps a backend error code of a failed block/unblock to a translation id. */
export var resolveBlockActionErrorMessageId = function (code) {
    var _a;
    return (_a = (code && BLOCK_ACTION_ERROR_MESSAGE_IDS[code])) !== null && _a !== void 0 ? _a : "ui-br-agency.product-number.error.blockAction";
};
